import { Component } from '@angular/core';


import * as LISTFORMAT_DATA from '../../../../assets/tests/data/listsFormat.json'
import { MatAccordion, MatExpansionPanel, MatExpansionPanelHeader } from "@angular/material/expansion"; 
import { ListFormat } from '../flowchart/interface/list-format';

@Component({
  selector: 'app-list-format',
  imports: [MatAccordion, MatExpansionPanel, MatExpansionPanelHeader],
  templateUrl: './list-format.html',
  styleUrl: './list-format.scss',
})
export class ListFormatView {

    lstFormat: ListFormat[] = (LISTFORMAT_DATA as any).default as ListFormat[];
}
